// extracted by mini-css-extract-plugin
export default {"dropdown_indicator":"Select_dropdown_indicator__DvtEl","clear_indicator":"Select_clear_indicator__ZLdGH"};